export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/combination-tourist.53c30500-2621d3.png";